module.exports = __webpack_public_path__ + "static/img/class1.1488137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class1.png
// module id = oKZi
// module chunks = 0